module.exports = __webpack_public_path__ + "img/user.540643f1.png";